import React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import Layout from "../../../Components/LayoutApp";
import Client from "../../../Objects/models/Client";
import { RootState } from "../../../Redux/store";
import FirstStep from "./Course/Declaration/FirstStep";
import SecondStep from "./Course/Declaration/SecondStep";
import Stepper from "./Stepper";
import ThirdStep from "./Course/Declaration/ThirdStep";
import RecapStep from "./Course/Declaration/RecapStep";
import type { DataChildType, DataDisptachType } from "./CourseDeclare";
import FinalStep from "./Course/Declaration/FinalStep";

type Props = {
  dataChild: DataChildType;
  dataDispatch: DataDisptachType;
  client?: Client;
}


const IndexDeclaration = ({ dataChild, dataDispatch, client }: Props) => {
  const generalStep = useSelector((state: RootState) => state.declarationCourse);
  const step = generalStep?.courseType ? generalStep?.step : 1
  const [currentStep, setCurrentStep] = useState<any>(step ?? 1);

  const handleChangeStep = (val: number) => {
    setCurrentStep(val);
  };
  const renderStepScreen = (step: number) => {
    switch (step) {
      case 1:
        return <FirstStep handleChangeStep={handleChangeStep} client={client} generalStep={generalStep} dataChild={dataChild} dataDispatch={dataDispatch} />;
      case 2:
        return <SecondStep handleChangeStep={handleChangeStep} client={client} generalStep={generalStep} dataChild={dataChild} dataDispatch={dataDispatch} />
      case 3:
        return <ThirdStep handleChangeStep={handleChangeStep} client={client} generalStep={generalStep} dataChild={dataChild} dataDispatch={dataDispatch} />;
      case 4:
        return <RecapStep handleChangeStep={handleChangeStep} client={client} generalStep={generalStep} dataChild={dataChild} dataDispatch={dataDispatch} />;
      case 5:
        return <FinalStep handleChangeStep={handleChangeStep} generalStep={generalStep} client={client} />;
      default:
        return <FirstStep handleChangeStep={handleChangeStep} client={client} generalStep={generalStep} dataChild={dataChild} dataDispatch={dataDispatch} />;
    }
  };

  const getCurrentStep = (step: number) => {
    // if (step <= 0) return 0
    // return step - 1
    return Math.max(step - 1, 0)
  }


  return (
    <Layout className2="transparent">
      <div className="">
        <div className="/bg-[#F4FAFF] bg-[#FFFFFF] p-5">
          <div className="mx-auto">
            <div className="flex flex-col gap-4">
              <div>
                <h1 className="lg:text-[2vw] font-[900] text-first text-2xl">
                  Faites une demande de cours
                </h1>
                <p className="text-grey font-bold lg:text-[1.3vw] text-lg pt-2">
                  Veuillez noter que seuls les cours à domicile ouvrent droit à
                  l'avance immédiate de crédit d'impôt.
                </p>
                {/* <small>Étape actuelle 1 : {getCurrentStep(currentStep)}</small><br />
								<small>Étape actuelle 2 : {currentStep}</small> */}
              </div>
            </div>
            <div className="w-full /h-[calc(100vh-200px)]  flex flex-col-reverse lg:flex-row gap-4 lg:py-6">
              <div className="flex flex-col gap-y-4 bg-white lg:w-3/4 border-[rgba(0,0,0,0.1)]  border-[1px] shadow-dashboard-setup-intro-form rounded-lg lg:p-8 p-1 h-full">
                {renderStepScreen(currentStep)}
              </div>
              <Stepper
                nextStep={handleChangeStep}
                steps={[
                  "Choix de l'élève 🎓",
                  "Planning 🗓️",
                  "Matière et lieu 📚",
                  "Récapitulatif 📋",
                ]}
                currentStep={getCurrentStep(currentStep)}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default IndexDeclaration;
